import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import Dashboard from './pages/dashboard';
import AITextGenerator from './pages/ai-text-generator';
import StudentChat from './pages/student-chat';
import LanguageCoach from './pages/language-coach';
import TeacherChat from './pages/teacher-chat';
import EmployeeTool from './pages/employee-tool';
import EntrepreneurTool from './pages/entrepreneur-tool';
import HealthImprovement from './pages/health-improvement';
import GoldenSolution from './pages/golden-solution';
import GoldenSolutionResult from './pages/golden-solution-result';
import Login from './pages/login';
import Register from './pages/register';
import Portal from './pages/portal';
import Success from './pages/success';
import AtendimentoPremium from './pages/atendimento-premium';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Default redirect to /dashboard */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/portal" element={<Portal />} />
          <Route path="/success" element={<Success />} />
          <Route path="/atendimento-premium" element={<AtendimentoPremium />} />
          <Route path="/ai-text-generator" element={<AITextGenerator />} />
          <Route path="/student-chat" element={<StudentChat />} />
          <Route path="/teacher-chat" element={<TeacherChat />} />
          <Route path="/employee-tool" element={<EmployeeTool />} />
          <Route path="/entrepreneur-tool" element={<EntrepreneurTool />} />
          <Route path="/health-improvement" element={<HealthImprovement />} />
          <Route path="/language-coach" element={<LanguageCoach />} />
          <Route path="/golden-solution" element={<GoldenSolution />} />
          <Route path="/golden-solution-result" element={<GoldenSolutionResult />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          {/* Wildcard route must be last */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;